export type ValueOf<T> = T[keyof T];

/**
 * Stato del pre-auth hold (autorizzazione carta) per-sessione.
 *  - ACTIVE: hold piazzato, non ancora incassato
 *  - CAPTURED: incassato (settle dell'effettivo)
 *  - RELEASED: rilasciato (void: costo 0 / sessione annullata / finale < hold)
 *  - EXPIRED: scaduto (oltre la finestra del PSP) senza capture
 */
export const HoldStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  CAPTURED: 'CAPTURED',
  RELEASED: 'RELEASED',
  EXPIRED: 'EXPIRED',
});

export type HoldStatusValues = ValueOf<typeof HoldStatus>;
export type HoldStatusKeys = keyof typeof HoldStatus;
